/**
 * Thema „Datenstand" (PV-037, A6): wann zuletzt und wann als Nächstes aus Salesforce aktualisiert
 * wird — für alle Nutzer, nicht nur Admins. Die Sync-Regeln selbst zeigen wir bewusst nicht.
 */
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../../lib/api.js';
import { formatZeitpunkt } from '../../../lib/format-date.js';
import { HilfeHinweis } from './hilfe-hinweis.js';
import type { HilfeThemaProps } from './hilfe-typen.js';

export function ThemaDatenstand({ kompakt }: HilfeThemaProps) {
  const { t, i18n } = useTranslation();
  const query = useQuery({
    queryKey: ['hilfe', 'datenstand'],
    queryFn: () => api.getHilfeDatenstand(),
    staleTime: 60_000,
  });
  if (query.isError) return <HilfeHinweis fehler>{t('hilfe.seite.fehler')}</HilfeHinweis>;
  const d = query.data;
  if (!d) return <HilfeHinweis>{t('hilfe.seite.laedt')}</HilfeHinweis>;

  const zuletzt = d.letzter_lauf_am
    ? formatZeitpunkt(d.letzter_lauf_am, i18n.language)
    : t('hilfe.datenstand.noch_nie');
  const naechste = !d.automatik_an
    ? t('hilfe.datenstand.aus')
    : d.naechster_lauf_am
      ? formatZeitpunkt(d.naechster_lauf_am, i18n.language)
      : t('hilfe.datenstand.kein_termin');

  return (
    <div
      className={`space-y-2 ${kompakt ? 'text-xs' : 'text-sm'}`}
      style={{ color: 'var(--ink-2)' }}
    >
      <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1">
        <dt className="font-medium" style={{ color: 'var(--ink)' }}>
          {t('hilfe.datenstand.zuletzt')}
        </dt>
        <dd>{zuletzt}</dd>
        <dt className="font-medium" style={{ color: 'var(--ink)' }}>
          {t('hilfe.datenstand.naechste')}
        </dt>
        <dd>{naechste}</dd>
      </dl>
      <p>{t('hilfe.datenstand.einleitung')}</p>
    </div>
  );
}
